module.exports = __webpack_public_path__ + "img/login.a67f5f68.jpg";